import { useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Recruiters() {
  const navigate = useNavigate();

  const [recruiters] = useState([
    { id: 1, name: "Sanjay Kumar", company: "TechWorks", email: "sanjay@tech.com" },
    { id: 2, name: "Priya Verma", company: "HR Solutions", email: "priya@hr.com" },
    { id: 3, name: "Rajesh Gupta", company: "SkillHire", email: "raj@skill.com" }
  ]);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Recruiters</h1>

      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">Name</th>
            <th className="border p-2">Company</th>
            <th className="border p-2">Email</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>

        <tbody>
          {recruiters.map((rec) => (
            <tr key={rec.id}>
              <td className="border p-2">{rec.name}</td>
              <td className="border p-2">{rec.company}</td>
              <td className="border p-2">{rec.email}</td>
              <td className="border p-2 space-x-2">
                <button
                  onClick={() => navigate(`/recruit/details/${rec.id}`)}
                  className="bg-blue-600 text-white px-3 py-1 rounded"
                >
                  Details
                </button>
                <button
                  onClick={() => navigate(`/recruit/interviews?recruiterId=${rec.id}`)}
                  className="bg-green-600 text-white px-3 py-1 rounded"
                >
                  Schedule
                </button>
                <button
                  onClick={() => navigate(`/recruit/hiring?recruiterId=${rec.id}`)}
                  className="bg-purple-600 text-white px-3 py-1 rounded"
                >
                  Hiring
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
